const industries = require('../data/industries.json')

const Industries = {}

Industries.industries = industries

module.exports = Industries
